import { render, staticRenderFns } from "./mo-contact-card.html?vue&type=template&id=48cd8ab2&external"
import script from "./mo-contact-card.ts?vue&type=script&lang=ts&external"
export * from "./mo-contact-card.ts?vue&type=script&lang=ts&external"
import style0 from "./mo-contact-card.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/agent/_work/3/s/Be.Vlaanderen.Mo.Vue/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48cd8ab2')) {
      api.createRecord('48cd8ab2', component.options)
    } else {
      api.reload('48cd8ab2', component.options)
    }
    module.hot.accept("./mo-contact-card.html?vue&type=template&id=48cd8ab2&external", function () {
      api.rerender('48cd8ab2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/mo-contact-card/mo-contact-card.vue"
export default component.exports